import { defineMessages } from "react-intl";

import { EntityType } from "@mapmycustomers/shared/enum";

export const messages = defineMessages({
  downloadButton: {
    id: "listModalForCharts.downloadButton",
    defaultMessage: "Quick export",
    description: "Download entities button on the list modal",
  },
});

export const viewAllMessages = defineMessages<
  EntityType.ACTIVITY | EntityType.COMPANY | EntityType.DEAL | EntityType.PERSON
>({
  [EntityType.ACTIVITY]: {
    id: "listModalForCharts.viewAllActivities",
    defaultMessage: "View all Activities",
    description: "View all Activities link on the Activities list modal",
  },
  [EntityType.COMPANY]: {
    id: "listModalForCharts.viewAllCompanies",
    defaultMessage: "View all Companies",
    description: "View all Companies link on the Companies list modal",
  },
  [EntityType.DEAL]: {
    id: "listModalForCharts.viewAllDeals",
    defaultMessage: "View all Deals",
    description: "View all Deals link on the Deal list modal",
  },
  [EntityType.PERSON]: {
    id: "listModalForCharts.viewAllPeople",
    defaultMessage: "View all People",
    description: "View all People link on the People list modal",
  },
});
